import React, { useEffect } from 'react'
import { Button, Card, CardBody, CardTitle, Col, Form, Input, Label, Row, FormFeedback } from "reactstrap";
import * as yup from "yup";
import { useFormik } from "formik";
import { updateAdminSettings } from 'helpers/API Calls/System & Settings/Admin Settings';

interface AnalyticsData {
  GOOGLE_ANALYTICS_ID?: {
    id: string;
    value: string;
    can_update: number;
  };
}

interface Props {
  data: AnalyticsData;
}

function Analytics({ data }: Props) {
  const formik = useFormik({
    initialValues: {
      googleAnalyticsId: data?.GOOGLE_ANALYTICS_ID?.value || ''
    },    
    validationSchema: yup.object().shape({
      googleAnalyticsId: yup.string().required("Google Analytics ID is required")}),
    onSubmit: async (values: { googleAnalyticsId: string }, { setSubmitting }) => {
      setSubmitting(true);
      const reqData = [{
        key: "GOOGLE_ANALYTICS_ID",
        value: values.googleAnalyticsId || '',
        id: data.GOOGLE_ANALYTICS_ID?.id,
      }];
      
      const response = await updateAdminSettings({ 'settings': reqData });
      if (response) {
        setSubmitting(false);
      }
    }
  });  
  
  useEffect(() => {
    if (data?.GOOGLE_ANALYTICS_ID) {
      formik.setValues({
        googleAnalyticsId: data.GOOGLE_ANALYTICS_ID.value || ''
      });
    }
  }, [data]);

      
  return (
    <Card>
      <CardBody>
        <CardTitle tag="h4" className='mb-4'>Analytics Settings</CardTitle>
        <Form onSubmit={formik.handleSubmit} autoComplete="off">
          <div className="mb-4">
            <Row>
              <Col sm="6">
                <div className="mb-3">
                  <Label htmlFor="googleAnalyticsId">Google Analytics ID</Label>
                  <Input
                    id="googleAnalyticsId"
                    name="googleAnalyticsId"
                    type="text"
                    placeholder="Enter Google Analytics ID (UA-XXXXX-X or G-XXXXXXXXXX)"
                    value={formik.values.googleAnalyticsId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.googleAnalyticsId && formik.errors.googleAnalyticsId ? true : false}
                    disabled={data?.GOOGLE_ANALYTICS_ID?.can_update !== 1}
                  />
                  {formik.touched.googleAnalyticsId && formik.errors.googleAnalyticsId && (
                    <FormFeedback type="invalid">{String(formik.errors.googleAnalyticsId)}</FormFeedback>
                  )}
                </div>
              </Col>
            </Row>
          </div>

          <div className="d-flex flex-wrap gap-2 justify-content-end">
            <Button type="submit" color="primary" disabled={formik.isSubmitting}>
              {formik.isSubmitting ? 'Saving...' : 'Save Settings'}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  );
}

export default Analytics;
